import { render, staticRenderFns } from "./ObservationsTable.vue?vue&type=template&id=330a64bc&"
import script from "./ObservationsTable.vue?vue&type=script&lang=js&"
export * from "./ObservationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports